<div id="error-page-container">
    <div id="text-container">
        <h1 class="title">{{ 'unauthorizedPage.title' | translate }}</h1>

        <div class="content">
            <p>{{ 'unauthorizedPage.subtitle' | translate }}</p>
            <p class="small-width">
                <span [innerHTML]="'unauthorizedPage.descriptionPartOne' | translate"></span>
                <a href="mailto: help@transnetyx.com" class="link" (click)="logTransnetyxTag()">
                    {{ 'unauthorizedPage.tyxEmail' | translate }}
                </a>
                {{ 'unauthorizedPage.descriptionPartTwo' | translate }}
                <a href="tel: 888-321-2113" class="link"> {{ 'unauthorizedPage.phoneNumber' | translate }}</a
                >.
            </p>
        </div>

        <div class="action-buttons">
            <button
                id="error-page-sign-out-btn"
                pButton
                type="button"
                class="p-button p-button-lg"
                [label]="'serverErrorPage.signOut.button.text' | translate"
                (click)="logout()"></button>
            <button
                id="live-chat-btn"
                pButton
                type="button"
                icon="far fa-comments"
                class="p-button-outlined p-button-lg"
                [label]="'serverErrorPage.liveChat.button.text' | translate"
                (click)="openChat()"></button>
        </div>
    </div>

    <div id="image-container">
        <img
            height="450"
            width="800"
            [ngSrc]="'assets/images/illustrations/error_403.svg'"
            [alt]="'img.alt.permissionError' | translate" />
    </div>
</div>
